var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global_menu"},[_c('HeadlineBorder',{staticClass:"headline_border"},[_vm._v(_vm._s(_vm.self.name)+"のページURL")]),_c('Qr',{attrs:{"url":_vm.url}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }